import { render, staticRenderFns } from "./VuesticChat.vue?vue&type=template&id=3c3dc5df&scoped=true&"
import script from "./VuesticChat.vue?vue&type=script&lang=js&"
export * from "./VuesticChat.vue?vue&type=script&lang=js&"
import style0 from "./VuesticChat.vue?vue&type=style&index=0&id=3c3dc5df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3dc5df",
  null
  
)

export default component.exports